import axios from './axios';
import { mapToSelect } from './egm';

class Revenue {

    getCategories = async () => {
        return [
           { key: "ALL", value: -1, text: "All" },
           { key: "1", value: 1, text: "Category 1" },
           { key: "2", value: 2, text: "Category 2" },
        ]
    }

    getSummary = async (operatorId, weeks, categoryId, dataView, groupBy, regionId) => {
        const response = await axios.get(`Collections/revenue/dashboard/${operatorId},${weeks},${categoryId},${dataView},${groupBy},${regionId}`);
        return response.data;
    }

    getGraph = async (groupId, weeks, categoryId, reportType, varianceType, groupBy, regionId) => {
        const response = await axios.get(`Collections/revenue/dashboard/graph/${groupId},${weeks},${categoryId},${reportType},${varianceType},${groupBy},${regionId}`);
        return response.data;
    }

    getIncomeSummary = async (operatorId, weeks, categoryId, dataView, varianceType, groupBy, regionId) => {
        const response = await axios.get(`Collections/incomesecurity/dashboard/${operatorId},${weeks},${categoryId},${dataView},${varianceType},${groupBy},${regionId}`);
        return response.data;
    }
    
    getIncomeGraph = async (groupId, weeks, categoryId, reportType, varianceType, groupBy, regionId) => {
        const response = await axios.get(`Collections/incomesecurity/dashboard/graph/${groupId},${weeks},${categoryId},${reportType},${varianceType},${groupBy},${regionId}`);
        return response.data;
    }

    getRegions = async (operatorId) => {
        const response = await axios.get(`organisation/operatorregions/all/${operatorId}`);
        return mapToSelect(response.data);
    }
}

export default new Revenue();